window.mcb = window.mcb || {};
window.mcb.profileInfoBlock = (function () {
    const _logger = window.mcb.utilities.createLogger('pib', 'Profile Info Block');
    const toggleNewsSubscribe = function (subscribeLabel, unsubscribeLabel) {
        let form = document.querySelector(".infohub-news-subscription form");
        const formData = new FormData(form);
        const data = new URLSearchParams(formData);

        fetch(form.action, {
            method: 'POST',
            body: data,
        })
            .then(response => response.json())
            .then(data => {
                if (data.infoHubNewsSubscription) {
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").html(subscribeLabel);
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").addClass("subscribed");
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").addClass("mcb-button--success");
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").removeClass("mcb-button--outlined");
                }
                else {
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").html(unsubscribeLabel);
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").removeClass("subscribed");
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").removeClass("mcb-button--success");
                  $(".infohub-news-subscription form .infohub-new-subscription-btn").addClass("mcb-button--outlined");
                }
            })
            .catch(error => {
                _logger.error('Error:', error);
            });
    };

    return {
        toggleNewsSubscribe: toggleNewsSubscribe
    }
})();
